import { Box, Typography } from '@mui/material'
import { IInsuranceData } from '../../../../services/entityServices'
import { ReactElement, useMemo } from 'react'

interface InsuranceViewItemsPropsType {
    insuranceData: IInsuranceData
}
const insuranceReadAttributesIds = [
    'message',
    'errorMessage',
    'generalConditions',
    'specialConditions',
]
const InsuranceViewItems = (
    props: InsuranceViewItemsPropsType,
): ReactElement => {
    const { insuranceData } = props
    const viewData = useMemo(() => {
        return (
            insuranceData?.attributes
                ?.filter(
                    (i) => insuranceReadAttributesIds.includes(i.id) && i.value,
                )
                .map((i) => {
                    if (i.id === 'message') {
                        const message = i?.value?.reduce((a: any, i: any) => {
                            return a + i?.value
                        }, '')
                        return {
                            key: i?.name,
                            value: message,
                        }
                    } else {
                        return {
                            key: i?.name,
                            value: i?.value,
                        }
                    }
                }) || []
        )
    }, [insuranceData])
    return (
        <Box>
            {viewData?.map((i) => (
                <Box key={i?.key} sx={{ display: 'flex' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                        }}
                    >
                        <Typography>
                            {' '}
                            <span
                                style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                }}
                            >
                                {i.key + ' : '}
                            </span>
                            {i.value}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </Box>
    )
}
export default InsuranceViewItems
